import { BREAKPOINTS } from '../config';
import { disableScrollLenis, enableScrollLenis } from '../layout/lenis';
import { lockScroll, unlockScroll } from '../utils/lockscroll';

const root = document.documentElement;
const body = document.body;

const mq = window.matchMedia(`(max-width: ${BREAKPOINTS.mqTouch}px)`);

const rate =
  parseFloat(getComputedStyle(root).getPropertyValue('--preloader-rate')) || 1;

function applyStagger(elements, step = 0.1) {
  elements.forEach((el, index) => {
    el.style.transitionDelay = `${3 * rate + index * step}s`;
  });
}
function clearStagger(elements) {
  elements.forEach(el => {
    el.style.transitionDelay = '';
  });
}

function startPreloader() {
  root.setAttribute('data-page-loader', '');

  disableScrollLenis();
  lockScroll();
}
function stopPreloader() {
  enableScrollLenis();
  unlockScroll();
}

document.addEventListener('DOMContentLoaded', () => {
  if (!body.classList.contains('page-home') || mq.matches) return;

  const headerBody = document.querySelector('.header__body');
  const heroTitle = document.querySelector('.hero__title');
  const heroList = document.querySelector('.hero__list');

  if (!headerBody || !heroTitle || !heroList) return;

  const headerBodyElements = headerBody.querySelectorAll(
    '.custom-logo-link, .navmenu a, .actions__btns .btn-action'
  );

  const heroListElements = heroList.querySelectorAll('li');

  applyStagger(headerBodyElements, 0.06 * rate);
  applyStagger(heroListElements, 0.03 * rate);
  startPreloader();

  setTimeout(() => {
    clearStagger(headerBodyElements);
    clearStagger(heroListElements);
    stopPreloader();
    root.classList.remove('preloader-lock');
  }, 4500 * rate);
});

function handleBreakpoint() {
  if (body.classList.contains('page-home') && mq.matches) {
    root.setAttribute('data-page-loader', '');
    root.classList.remove('preloader-lock');
  }
}

mq.addEventListener('change', handleBreakpoint);
document.addEventListener('DOMContentLoaded', handleBreakpoint);

if (
  !mq.matches &&
  body.classList.contains('page-home') &&
  'scrollRestoration' in history
) {
  history.scrollRestoration = 'manual';
} else {
  history.scrollRestoration = 'auto';
}
